var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-modalpopup-content bto-sb-tost-notifications",staticStyle:{"right":"0","bottom":"0"}},[_c('toast-notification',{attrs:{"showAllMessages":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }